module.exports = __webpack_public_path__ + "img/Customized.81691f53.png";